import AddAndEdit from "../components/addAndEditOrder/AddAndEdit";
import { ReactSelect } from "../components/kits/Inputs/Inputs";
import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useAxios from "../services/useAxios";
import { translateToReactSelect } from "../utils/helperFunction";
import { Helmet } from "react-helmet";
export default function AddAndEditOrders() {
  let { orderId } = useParams();
  const [orderData, setOrderData] = useState({});
  const { loading, execute } = useAxios("api2/orders_list");
  let navigate = useNavigate();
  useEffect(() => {
    orderId != "create" &&
      execute({ order_id: orderId }).then((result) => {
        let temp = result?.orders[0];
        if (result.orders.length == 0) navigate("/");
        setOrderData({
          ...temp,
          items: temp.order_items.map((value, index) => {
            let OPItem = JSON.parse(value.OptionOrderItem);
            let OOS = value.option_order_p_service_link.map((s) => {
              return {
                ...s,
                values: s.values.map((a) => {
                  return { ...a, value: JSON.parse(a.value) };
                }),
              };
            });

            OPItem.map((opvalue) => {
              for (let i = 0; i < OOS.length; i++) {
                if (OOS[i].option_order_id == opvalue[0].id) {
                  OOS[i] = {
                    ...OOS[i],
                    values: OOS[i].values.map((v) => {
                      if (v.id == opvalue.value[0].id) {
                        return {
                          ...v,
                          value: { ...v.value, checked: true },
                        };
                      } else
                        return {
                          ...v,
                          value: { ...v.value, checked: false },
                        };
                    }),
                  };
                }
              }
            });
            let selectedField = JSON.parse(value.params);
            console.log("debug edit array0",value,selectedField);
            return {
              ...value,
              id: index,
              OptionOrderItem: OPItem,
              product: {
                label: value.title,
                value: value.product_service_id,
                product_structure_id: value.product_structure_id,
                price: value.price,
                product_options: value.p_service_p_option_link.map((value) => {
                  return {
                    ...value,
                    0: {
                      id: value.p_option_id,
                      title: value.title,
                    },
                    selected:selectedField.filter((t)=>t[0].id == value.p_option_id)[0]?.selected,
                    //  selectedField?.filter((t) => {
                    //   console.log("debug t**",t,value);
                    //   if (t[0].id == value.p_option_id) {
                    //     console.log("debug t** selected",[t.selected]);
                    //     return t.selected}
                    //   else return {};
                    // }),
                    value: value.values,
                  };
                }),
                order_options: OOS.map((value) => {
                  return {
                    ...value,
                    0: {
                      id: value?.option_order_id,
                      title: value?.title,
                    },
                    value: value?.values,
                  };
                }),
              },
            };
          }),
        });
      });
  }, []);
  console.log('order data',orderData );
  return (
    <div className="">
      <Helmet>
        <title>{orderId!="create"?"ویرایش سفارش":"ایجاد سفارش"}</title>
      </Helmet>
      <AddAndEdit
        orderData={orderData}
        type={orderId == "create" ? "add" : "edit"}
      />
    </div>
  );
}
